export default __webpack_public_path__ + "static/media/site-top-mb.f6d73b0f.jpg";